/* Shinplex verified reviews widget — Judge.me / Stamped-style */
(() => {
  const root = document.querySelector('[data-spx-reviews]');
  if (!root) return;

  const els = {
    loading: root.querySelector('[data-spx-loading]'),
    error: root.querySelector('[data-spx-error]'),
    summary: root.querySelector('[data-spx-summary]'),
    avg: root.querySelector('[data-spx-avg]'),
    avgStars: root.querySelector('[data-spx-avg-stars]'),
    count: root.querySelector('[data-spx-count]'),
    bars: root.querySelector('[data-spx-bars]'),
    photos: root.querySelector('[data-spx-photos]'),
    carouselTrack: root.querySelector('[data-spx-carousel-track]'),
    carouselPrev: root.querySelector('[data-spx-carousel-prev]'),
    carouselNext: root.querySelector('[data-spx-carousel-next]'),
    toolbar: root.querySelector('[data-spx-toolbar]'),
    clear: root.querySelector('[data-spx-clear]'),
    list: root.querySelector('[data-spx-list]'),
    actions: root.querySelector('[data-spx-actions]'),
    more: root.querySelector('[data-spx-more]'),
  };

  const lightbox = document.querySelector('[data-spx-lightbox]');
  const lightboxImg = lightbox && lightbox.querySelector('[data-spx-lightbox-img]');

  const PAGE = Math.max(1, parseInt(root.dataset.pageSize || '3', 10) || 3);
  const INITIAL = Math.max(1, parseInt(root.dataset.initial || '3', 10) || 3);

  let all = [];
  let filtered = [];
  let shown = 0;
  let activeRating = null;
  let distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  let photoUrls = [];

  const shuffle = (arr) => {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const starsHtml = (n, cls = '') => {
    const full = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
    let out = `<span class="spx-stars ${cls}" aria-label="${full} out of 5 stars">`;
    for (let i = 1; i <= 5; i++) {
      out += `<span class="spx-star${i <= full ? ' is-on' : ''}" aria-hidden="true">★</span>`;
    }
    return out + '</span>';
  };

  const formatDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso + (iso.length === 10 ? 'T00:00:00Z' : ''));
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const escapeHtml = (s) =>
    String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  // Deprecated Pads (handle: shinplex) → flagship mouldable Guards product URL.
  const FLAGSHIP_GUARDS_HANDLE = 'shinplex™-mouldable-shin-guards';
  const FLAGSHIP_GUARDS_URL = `/products/${encodeURIComponent(FLAGSHIP_GUARDS_HANDLE)}`;
  const FLAGSHIP_GUARDS_LABEL = 'Shinplex™ Mouldable Shin Guards';

  const productAttribution = (handle) => {
    const h = String(handle || '').trim();
    if (!h) return null;
    if (h === 'shinplex' || h === 'Shinplex™ Mouldable Shin Pads' || /mouldable shin pads/i.test(h)) {
      return { href: FLAGSHIP_GUARDS_URL, label: FLAGSHIP_GUARDS_LABEL };
    }
    if (h === FLAGSHIP_GUARDS_HANDLE || /mouldable shin guards/i.test(h)) {
      return { href: FLAGSHIP_GUARDS_URL, label: FLAGSHIP_GUARDS_LABEL };
    }
    return { href: `/products/${encodeURIComponent(h)}`, label: h };
  };

  const reviewImages = (r) => {
    const fromImages = Array.isArray(r.image_urls) ? r.image_urls : [];
    const fromPictures = Array.isArray(r.picture_urls) ? r.picture_urls : [];
    const seen = new Set();
    const urls = [];
    [...fromImages, ...fromPictures].forEach((url) => {
      if (!url || seen.has(url)) return;
      seen.add(url);
      urls.push(url);
    });
    return urls;
  };

  const collectPhotos = (reviews) => {
    const seen = new Set();
    const urls = [];
    reviews.forEach((r) => {
      reviewImages(r).forEach((url) => {
        if (!seen.has(url)) {
          seen.add(url);
          urls.push(url);
        }
      });
    });
    return urls;
  };

  const pickTopRandom = (pool, n) => {
    const withBody = pool.filter((r) => (r.body || '').trim().length >= 20);
    const five = withBody.filter((r) => r.rating === 5);
    const base = five.length >= n ? five : withBody.length >= n ? withBody : pool;
    return shuffle(base).slice(0, Math.min(n, base.length));
  };

  const computeStats = (reviews) => {
    const dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    let sum = 0;
    reviews.forEach((r) => {
      const rating = Math.max(1, Math.min(5, Number(r.rating) || 0));
      dist[rating] = (dist[rating] || 0) + 1;
      sum += rating;
    });
    const count = reviews.length;
    const avg = count ? sum / count : 0;
    return { dist, count, avg };
  };

  const cardHtml = (r) => {
    const imgs = reviewImages(r);
    const media =
      imgs.length > 0
        ? `<div class="spx-review__media">${imgs
            .map(
              (url, i) =>
                `<button type="button" class="spx-review__thumb" data-spx-img="${escapeHtml(url)}" aria-label="View review photo ${i + 1}"><img src="${escapeHtml(url)}" alt="" loading="lazy" decoding="async"></button>`
            )
            .join('')}</div>`
        : '';
    const attr = productAttribution(r.product);
    const productHtml = attr
      ? `<a href="${escapeHtml(attr.href)}" class="spx-review__product mono-label">${escapeHtml(attr.label)}</a>`
      : '';
    return `<article class="spx-review" data-rating="${r.rating}">
      <header class="spx-review__head">
        ${starsHtml(r.rating)}
        <time class="spx-review__date mono-label" datetime="${escapeHtml(r.date)}">${escapeHtml(formatDate(r.date))}</time>
      </header>
      ${r.title ? `<h3 class="spx-review__title">${escapeHtml(r.title)}</h3>` : ''}
      ${r.body ? `<p class="spx-review__body">${escapeHtml(r.body)}</p>` : ''}
      ${media}
      <footer class="spx-review__foot">
        <span class="spx-review__author-row">
          <span class="spx-review__author">${escapeHtml(r.author || 'Verified buyer')}</span>
          <span class="spx-review__verified" aria-label="Verified review">
            <svg class="spx-review__verified-icon" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
              <circle cx="6" cy="6" r="6" fill="currentColor"/>
              <path d="M3.4 6.15l1.55 1.55 3.45-3.5" fill="none" stroke="#0a1510" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="spx-review__verified-text">Verified</span>
          </span>
        </span>
        ${productHtml}
      </footer>
    </article>`;
  };

  const updateCarouselNav = () => {
    if (!els.carouselTrack || !els.carouselPrev || !els.carouselNext) return;
    const track = els.carouselTrack;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;
    els.carouselPrev.disabled = photoUrls.length === 0 || atStart;
    els.carouselNext.disabled = photoUrls.length === 0 || atEnd || maxScroll <= 0;
  };

  const scrollCarousel = (dir) => {
    if (!els.carouselTrack) return;
    const step = Math.max(160, Math.floor(els.carouselTrack.clientWidth * 0.75));
    els.carouselTrack.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  const renderCarousel = () => {
    if (!els.photos || !els.carouselTrack) return;
    els.photos.hidden = false;
    if (!photoUrls.length) {
      els.carouselTrack.innerHTML = '';
      els.carouselTrack.classList.add('is-empty');
      els.photos.classList.add('is-empty');
      updateCarouselNav();
      return;
    }
    els.carouselTrack.classList.remove('is-empty');
    els.photos.classList.remove('is-empty');
    els.carouselTrack.innerHTML = photoUrls
      .map(
        (url, i) =>
          `<button type="button" class="spx-reviews__carousel-slide" data-spx-img="${escapeHtml(url)}" aria-label="View player photo ${i + 1}"><img src="${escapeHtml(url)}" alt="" loading="lazy" decoding="async"></button>`
      )
      .join('');
    requestAnimationFrame(updateCarouselNav);
  };

  const renderBars = () => {
    const max = Math.max(1, ...Object.values(distribution));
    els.bars.innerHTML = [5, 4, 3, 2, 1]
      .map((star) => {
        const n = distribution[star] || 0;
        const pct = Math.round((n / max) * 100);
        const active = activeRating === star ? ' is-active' : '';
        const empty = n === 0 ? ' is-empty' : '';
        return `<button type="button" class="spx-bar${active}${empty}" data-spx-filter="${star}" aria-pressed="${activeRating === star}">
          <span class="spx-bar__label mono-label">${star} ★</span>
          <span class="spx-bar__track"><span class="spx-bar__fill" style="width:${pct}%"></span></span>
          <span class="spx-bar__count mono-label">${n}</span>
        </button>`;
      })
      .join('');
  };

  const renderList = (reset) => {
    if (reset) {
      els.list.innerHTML = '';
      shown = 0;
    }
    // Always start at INITIAL (3), including when a star filter is active; then +PAGE.
    const batchSize = shown === 0 ? INITIAL : PAGE;
    const batch = filtered.slice(shown, shown + batchSize);
    if (!batch.length && shown === 0) {
      els.list.innerHTML = `<p class="spx-reviews__empty">No reviews with this rating</p>`;
    } else {
      els.list.insertAdjacentHTML('beforeend', batch.map(cardHtml).join(''));
      shown += batch.length;
    }
    const remaining = filtered.length - shown;
    els.actions.hidden = remaining <= 0;
    if (els.more) {
      els.more.textContent = remaining > 0 ? `Load more reviews (${remaining})` : 'Load more reviews';
    }
    if (els.clear) {
      els.clear.hidden = activeRating == null;
      els.toolbar.hidden = activeRating == null;
    }
  };

  const applyFilter = (rating) => {
    activeRating = rating;
    if (rating == null) {
      const top = pickTopRandom(all, INITIAL);
      const topIds = new Set(top.map((r) => r.id));
      const rest = all
        .filter((r) => !topIds.has(r.id))
        .sort((a, b) => String(b.date).localeCompare(String(a.date)));
      filtered = top.concat(rest);
    } else {
      filtered = all
        .filter((r) => r.rating === rating)
        .sort((a, b) => String(b.date).localeCompare(String(a.date)));
    }
    renderBars();
    renderList(true);
  };

  const openLightbox = (url) => {
    if (!url || !lightbox || !lightboxImg) return;
    lightboxImg.src = url;
    lightboxImg.alt = 'Review photo';
    if (typeof lightbox.showModal === 'function') lightbox.showModal();
  };

  root.addEventListener('click', (e) => {
    const filterBtn = e.target.closest('[data-spx-filter]');
    if (filterBtn && root.contains(filterBtn)) {
      const star = parseInt(filterBtn.dataset.spxFilter, 10);
      if (!star) return;
      applyFilter(activeRating === star ? null : star);
      return;
    }
    if (e.target.closest('[data-spx-clear]')) {
      applyFilter(null);
      return;
    }
    if (e.target.closest('[data-spx-more]')) {
      renderList(false);
      return;
    }
    if (e.target.closest('[data-spx-carousel-prev]')) {
      scrollCarousel(-1);
      return;
    }
    if (e.target.closest('[data-spx-carousel-next]')) {
      scrollCarousel(1);
      return;
    }
    const thumb = e.target.closest('[data-spx-img]');
    if (thumb) {
      openLightbox(thumb.dataset.spxImg);
    }
  });

  if (els.carouselTrack) {
    els.carouselTrack.addEventListener('scroll', updateCarouselNav, { passive: true });
  }

  if (lightbox) {
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) lightbox.close();
    });
  }

  const src = root.dataset.src;
  if (!src) {
    els.loading.hidden = true;
    els.error.hidden = false;
    els.error.textContent = 'Reviews data URL missing.';
    return;
  }

  fetch(src, { credentials: 'same-origin' })
    .then((res) => {
      if (!res.ok) throw new Error('Failed to load reviews');
      return res.json();
    })
    .then((data) => {
      all = Array.isArray(data.reviews) ? data.reviews : [];
      const stats = computeStats(all);
      const hist = data.rating_histogram;
      if (hist && typeof hist === 'object') {
        distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        [1, 2, 3, 4, 5].forEach((star) => {
          const n = Number(hist[star] ?? hist[String(star)]);
          distribution[star] = Number.isFinite(n) && n >= 0 ? n : 0;
        });
      } else {
        distribution = stats.dist;
      }
      photoUrls = collectPhotos(all);
      els.loading.hidden = true;
      if (!all.length) {
        els.error.hidden = false;
        els.error.textContent = 'No reviews available yet.';
        renderCarousel();
        return;
      }
      els.summary.hidden = false;
      els.avg.textContent = stats.avg.toFixed(1);
      els.avgStars.innerHTML = starsHtml(Math.round(stats.avg));
      const displayCount = Number(data.display_count) > 0 ? Number(data.display_count) : stats.count;
      els.count.textContent = `${displayCount} review${displayCount === 1 ? '' : 's'}`;
      renderCarousel();
      applyFilter(null);
    })
    .catch(() => {
      els.loading.hidden = true;
      els.error.hidden = false;
      els.error.textContent = 'Could not load reviews. Please refresh.';
    });
})();
